// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file sidecar/v1/scale_local_api.proto (package sidecar.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Unit } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sidecar/v1/scale_local_api.proto.
 */
export const file_sidecar_v1_scale_local_api: GenFile = /*@__PURE__*/
  fileDesc("CiBzaWRlY2FyL3YxL3NjYWxlX2xvY2FsX2FwaS5wcm90bxIKc2lkZWNhci52MSKJAQoJU2NhbGVJbmZvEhAKCHNjYWxlX2lkGAEgASgJEgwKBG5hbWUYAiABKAkSFwoPY29ubmVjdGlvbl90eXBlGAMgASgJEhkKEXNjYWxlX2Zvcm1hdF90eXBlGAQgASgJEhgKEG1lYXN1cmVtZW50X21vZGUYBSABKAkSDgoGb25saW5lGAYgASgIIp0BCgxXZWlnaHRVcGRhdGUSFAoMZ3Jvc3Nfd2VpZ2h0GAEgASgBEhMKC3RhcmVfd2VpZ2h0GAIgASgBEhIKCm5ldF93ZWlnaHQYAyABKAESKAoTdW5pdF9vZl9tZWFzdXJlbWVudBgEIAEoDjILLnR5cGVzLlVuaXQSFAoMdGltZXN0YW1wX21zGAUgASgDEg4KBnN0YWJsZRgGIAEoCCITChFMaXN0U2NhbGVzUmVxdWVzdCI7ChJMaXN0U2NhbGVzUmVzcG9uc2USJQoGc2NhbGVzGAEgAygLMhUuc2lkZWNhci52MS5TY2FsZUluZm8iJwoTR2V0U2NhbGVJbmZvUmVxdWVzdBIQCghzY2FsZV9pZBgBIAEoCSI8ChRHZXRTY2FsZUluZm9SZXNwb25zZRIkCgVzY2FsZRgBIAEoCzIVLnNpZGVjYXIudjEuU2NhbGVJbmZvIisKF0dldEN1cnJlbnRXZWlnaHRSZXF1ZXN0EhAKCHNjYWxlX2lkGAEgASgJIkQKGEdldEN1cnJlbnRXZWlnaHRSZXNwb25zZRIoCgZ3ZWlnaHQYASABKAsyGC5zaWRlY2FyLnYxLldlaWdodFVwZGF0ZSIqChZTdWJzY3JpYmVXZWlnaHRSZXF1ZXN0EhAKCHNjYWxlX2lkGAEgASgJMuUCChFTY2FsZUxvY2FsU2VydmljZRJLCgpMaXN0U2NhbGVzEh0uc2lkZWNhci52MS5MaXN0U2NhbGVzUmVxdWVzdBoeLnNpZGVjYXIudjEuTGlzdFNjYWxlc1Jlc3BvbnNlElEKDEdldFNjYWxlSW5mbxIfLnNpZGVjYXIudjEuR2V0U2NhbGVJbmZvUmVxdWVzdBogLnNpZGVjYXIudjEuR2V0U2NhbGVJbmZvUmVzcG9uc2USXQoQR2V0Q3VycmVudFdlaWdodBIjLnNpZGVjYXIudjEuR2V0Q3VycmVudFdlaWdodFJlcXVlc3QaJC5zaWRlY2FyLnYxLkdldEN1cnJlbnRXZWlnaHRSZXNwb25zZRJRCg9TdWJzY3JpYmVXZWlnaHQSIi5zaWRlY2FyLnYxLlN1YnNjcmliZVdlaWdodFJlcXVlc3QaGC5zaWRlY2FyLnYxLldlaWdodFVwZGF0ZTABQixaKnBhY2thZ2VzL3NlcnZpY2Utc2lkZWNhci9hcGkvdjE7c2lkZWNhcl92MWIIZWRpdGlvbnNw6Ac", [file_types]);

/**
 * @generated from message sidecar.v1.ScaleInfo
 */
export type ScaleInfo = Message<"sidecar.v1.ScaleInfo"> & {
  /**
   * @generated from field: string scale_id = 1;
   */
  scaleId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string connection_type = 3;
   */
  connectionType: string;

  /**
   * @generated from field: string scale_format_type = 4;
   */
  scaleFormatType: string;

  /**
   * @generated from field: string measurement_mode = 5;
   */
  measurementMode: string;

  /**
   * @generated from field: bool online = 6;
   */
  online: boolean;
};

/**
 * Describes the message sidecar.v1.ScaleInfo.
 * Use `create(ScaleInfoSchema)` to create a new message.
 */
export const ScaleInfoSchema: GenMessage<ScaleInfo> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 0);

/**
 * @generated from message sidecar.v1.WeightUpdate
 */
export type WeightUpdate = Message<"sidecar.v1.WeightUpdate"> & {
  /**
   * @generated from field: double gross_weight = 1;
   */
  grossWeight: number;

  /**
   * @generated from field: double tare_weight = 2;
   */
  tareWeight: number;

  /**
   * @generated from field: double net_weight = 3;
   */
  netWeight: number;

  /**
   * @generated from field: types.Unit unit_of_measurement = 4;
   */
  unitOfMeasurement: Unit;

  /**
   * @generated from field: int64 timestamp_ms = 5;
   */
  timestampMs: bigint;

  /**
   * @generated from field: bool stable = 6;
   */
  stable: boolean;
};

/**
 * Describes the message sidecar.v1.WeightUpdate.
 * Use `create(WeightUpdateSchema)` to create a new message.
 */
export const WeightUpdateSchema: GenMessage<WeightUpdate> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 1);

/**
 * @generated from message sidecar.v1.ListScalesRequest
 */
export type ListScalesRequest = Message<"sidecar.v1.ListScalesRequest"> & {
};

/**
 * Describes the message sidecar.v1.ListScalesRequest.
 * Use `create(ListScalesRequestSchema)` to create a new message.
 */
export const ListScalesRequestSchema: GenMessage<ListScalesRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 2);

/**
 * @generated from message sidecar.v1.ListScalesResponse
 */
export type ListScalesResponse = Message<"sidecar.v1.ListScalesResponse"> & {
  /**
   * @generated from field: repeated sidecar.v1.ScaleInfo scales = 1;
   */
  scales: ScaleInfo[];
};

/**
 * Describes the message sidecar.v1.ListScalesResponse.
 * Use `create(ListScalesResponseSchema)` to create a new message.
 */
export const ListScalesResponseSchema: GenMessage<ListScalesResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 3);

/**
 * @generated from message sidecar.v1.GetScaleInfoRequest
 */
export type GetScaleInfoRequest = Message<"sidecar.v1.GetScaleInfoRequest"> & {
  /**
   * @generated from field: string scale_id = 1;
   */
  scaleId: string;
};

/**
 * Describes the message sidecar.v1.GetScaleInfoRequest.
 * Use `create(GetScaleInfoRequestSchema)` to create a new message.
 */
export const GetScaleInfoRequestSchema: GenMessage<GetScaleInfoRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 4);

/**
 * @generated from message sidecar.v1.GetScaleInfoResponse
 */
export type GetScaleInfoResponse = Message<"sidecar.v1.GetScaleInfoResponse"> & {
  /**
   * @generated from field: sidecar.v1.ScaleInfo scale = 1;
   */
  scale?: ScaleInfo;
};

/**
 * Describes the message sidecar.v1.GetScaleInfoResponse.
 * Use `create(GetScaleInfoResponseSchema)` to create a new message.
 */
export const GetScaleInfoResponseSchema: GenMessage<GetScaleInfoResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 5);

/**
 * @generated from message sidecar.v1.GetCurrentWeightRequest
 */
export type GetCurrentWeightRequest = Message<"sidecar.v1.GetCurrentWeightRequest"> & {
  /**
   * @generated from field: string scale_id = 1;
   */
  scaleId: string;
};

/**
 * Describes the message sidecar.v1.GetCurrentWeightRequest.
 * Use `create(GetCurrentWeightRequestSchema)` to create a new message.
 */
export const GetCurrentWeightRequestSchema: GenMessage<GetCurrentWeightRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 6);

/**
 * @generated from message sidecar.v1.GetCurrentWeightResponse
 */
export type GetCurrentWeightResponse = Message<"sidecar.v1.GetCurrentWeightResponse"> & {
  /**
   * @generated from field: sidecar.v1.WeightUpdate weight = 1;
   */
  weight?: WeightUpdate;
};

/**
 * Describes the message sidecar.v1.GetCurrentWeightResponse.
 * Use `create(GetCurrentWeightResponseSchema)` to create a new message.
 */
export const GetCurrentWeightResponseSchema: GenMessage<GetCurrentWeightResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 7);

/**
 * @generated from message sidecar.v1.SubscribeWeightRequest
 */
export type SubscribeWeightRequest = Message<"sidecar.v1.SubscribeWeightRequest"> & {
  /**
   * @generated from field: string scale_id = 1;
   */
  scaleId: string;
};

/**
 * Describes the message sidecar.v1.SubscribeWeightRequest.
 * Use `create(SubscribeWeightRequestSchema)` to create a new message.
 */
export const SubscribeWeightRequestSchema: GenMessage<SubscribeWeightRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_scale_local_api, 8);

/**
 * @generated from service sidecar.v1.ScaleLocalService
 */
export const ScaleLocalService: GenService<{
  /**
   * @generated from rpc sidecar.v1.ScaleLocalService.ListScales
   */
  listScales: {
    methodKind: "unary";
    input: typeof ListScalesRequestSchema;
    output: typeof ListScalesResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.ScaleLocalService.GetScaleInfo
   */
  getScaleInfo: {
    methodKind: "unary";
    input: typeof GetScaleInfoRequestSchema;
    output: typeof GetScaleInfoResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.ScaleLocalService.GetCurrentWeight
   */
  getCurrentWeight: {
    methodKind: "unary";
    input: typeof GetCurrentWeightRequestSchema;
    output: typeof GetCurrentWeightResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.ScaleLocalService.SubscribeWeight
   */
  subscribeWeight: {
    methodKind: "server_streaming";
    input: typeof SubscribeWeightRequestSchema;
    output: typeof WeightUpdateSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_sidecar_v1_scale_local_api, 0);

